import { fetchCompanyGroupSettings } from '../../service/settingService'
import companyGroupSettingQueryKeys from './companyGroupSettingQueryKeys'
import { GroupSettingData } from '../../types/CompanyGroupSettings'

export const getCompanyGroupSettingsOptions = <TData = GroupSettingData>(
  companyId: string,
  select?: (data: GroupSettingData) => TData
) => {
  return {
    queryKey: companyGroupSettingQueryKeys.setting(companyId),
    queryFn: fetchCompanyGroupSettings,
    gcTime: 30 * 60 * 1000,
    staleTime: 15 * 60 * 1000,
    enabled: !!companyId,
    select
  }
}
